import { useProductSelector } from '@wajeez-web/stores/product';

export const useGetPromoCodeAliasesLookups = () => {
  return useProductSelector(({ promoCodeAliases }) => promoCodeAliases.lookups);
};
